import script from "./UploadDocumentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadDocumentForm.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=2036635a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2036635a"]])

export default __exports__